import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { sixYardAxios } from '../../sixYardAxios';
import Birthdays from '../../components/activities/birthdays/birthdays';
import TeamBuilding from '../../components/activities/teamBuilding/teamBuilding';
import Events from '../../components/activities/events/events';
import { authCheckState } from "../../store/actions";
import LoginModal from '../../components/containers/loginModal/loginModal';

const Activities = (props) => {
    const { slug } = useParams();
    const [birthdaysGallery, setBirthdaysGallery] = useState([]);
    const [teamBuildingGallery, setTeamBuildingGallery] = useState([]);
    const [eventsGallery, setEventsGallery] = useState([]);
    const [foodCategory, setFoodCategory] = useState([]);
    const [cakes, setCakes] = useState([]);
    const [pizza, setPizza] = useState([]);
    const [pasta, setPasta] = useState([]);
    const [burgers, setBurgers] = useState([]);
    const [snacks, setSnacks] = useState([]);
    const [packages, setPackages] = useState([]);
    const [services, setServices] = useState([]);
    const [eventTypes, setEventTypes] = useState([]);
    const [birthdayTypes, setBirthdayTypes] = useState([]);
    const [teamBuildingTypes, setTeamBuildingTypes] = useState([]);
    const [birthdayRegistrationId, setBirthdayRegistrationId] = useState(null);
    const [birthdayPaymentData, setBirthdayPaymentData] = useState(null);
    const [birthdayBookingDate, setBirthdayBookingDate] = useState(null);
    const [showLoginForm, setShowLoginForm] = useState(false);
    
    // Initial setup
    useEffect(() => {
        fetchActivityTypes();
    }, []);
    
    useEffect(() => {
        props.isAuthenticated && setShowLoginForm(false);
    }, [props.isAuthenticated]);
    
    // Replace storage event with Redux language monitoring
    // This effect runs whenever the Redux language setting changes
    useEffect(() => {
        console.log("Language changed in Redux: ", props.language);
        fetchActivityTypes();
        slug === 'birthdays' && fetchServices();
        (slug === 'birthdays' || slug === 'team-building') && fetchFoodCategory();
        (slug === 'birthdays' || slug === 'team-building') && fetchPackages();
        slug === 'birthdays' && fetchGallery("birthdays", setBirthdaysGallery);
        slug === 'team-building' && fetchGallery("team-building", setTeamBuildingGallery);
        slug === 'events' && fetchGallery("events", setEventsGallery);
    }, [slug, props.language]);
    
    const fetchGallery = async (activity, setActivity) => {
        try {
            // Use Redux language state instead of localStorage directly
            const lang = props.language;
            const res = await sixYardAxios.get(`/gallery/${activity}?lang=${lang}`);
            setActivity(res.data.data);
        } catch (error) {
            console.error("Error fetching gallery:", error);
        }
    };

    const fetchFoodCategory = async () => {
        try {
            // Use Redux language state instead of localStorage directly
            const lang = props.language;
            const res = await sixYardAxios.get(`/food/categories?lang=${lang}`);
            
            console.log("Food categories:", res.data.data.map(cat => cat.name));
            setFoodCategory(res.data.data);
            
            const pizzaCategory = res.data.data.find(category => 
                category.name === "Pizza" || category.name === "بيتزا");
            setPizza(pizzaCategory?.items || []);
            
            const burgersCategory = res.data.data.find(category => 
                category.name === "Burgers" || category.name === "البرغر");
            setBurgers(burgersCategory?.items || []);
            
            const snacksCategory = res.data.data.find(category => 
                category.name === "Snacks" || category.name === "الوجبات الخفيفة");
            setSnacks(snacksCategory?.items || []);
            
            const cakeCategory = res.data.data.find(category => 
                category.name === "Cake" || category.name === "كعكة");
            setCakes(cakeCategory?.items || []);
            
            setPasta([]);
            
        } catch (error) {
            console.error("Error fetching food categories:", error);
        }
    };

    const fetchPackages = async () => {
        try {
            // Use Redux language state instead of localStorage directly
            const lang = props.language;
            const res = await sixYardAxios.get(`/food/packages?lang=${lang}`);
            setPackages(res.data.data);
        } catch (error) {
            console.error("Error fetching packages:", error);
        }
    };
    
    const fetchServices = async () => {
        try {
            // Use Redux language state instead of localStorage directly
            const lang = props.language;
            const res = await sixYardAxios.get(`/services?lang=${lang}`);
            setServices(res.data.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };
    
    const fetchActivityTypes = async () => {
        try {
            // Use Redux language state instead of localStorage directly
            const lang = props.language;
            const res = await sixYardAxios.get(`/activities/types?lang=${lang}`);
            setEventTypes(res.data.data?.types.find(type => type.slug === "events"));
            setBirthdayTypes(res.data.data?.types.find(type => type.slug === "birthday-party"));
            setTeamBuildingTypes(res.data.data?.types.find(type => type.slug === "team-building"));
        } catch (error) {
            console.error("Error fetching activity types:", error);
        }
    };

    return (
        <div>
            {slug === 'birthdays' && <Birthdays imageList={birthdaysGallery} packages={packages}
                cakes={cakes} pizza={pizza} pasta={pasta} burgers={burgers} snacks={snacks}
                birthdayTypes={birthdayTypes} birthdayRegistrationId={birthdayRegistrationId} 
                setBirthdayRegistrationId={setBirthdayRegistrationId} services={services}
                setBirthdayPaymentData={setBirthdayPaymentData} birthdayPaymentData={birthdayPaymentData}
                setBirthdayBookingDate={setBirthdayBookingDate} birthdayBookingDate={birthdayBookingDate}
                isAuthenticated={props.isAuthenticated}
                setShowLoginForm={setShowLoginForm}/>}
            {slug === 'team-building' && <TeamBuilding imageList={teamBuildingGallery} packages={packages}
                pizza={pizza} pasta={pasta} cakes={cakes} burgers={burgers} snacks={snacks}
                teamBuildingTypes={teamBuildingTypes} isAuthenticated={props.isAuthenticated}
                setShowLoginForm={setShowLoginForm}/>}
            {slug === 'events' && <Events imageList={eventsGallery} eventTypes={eventTypes} isAuthenticated={props.isAuthenticated}
                setShowLoginForm={setShowLoginForm}/>}
            {showLoginForm && <LoginModal setShowLoginForm={setShowLoginForm} currentPath={'/activities/'+slug}/>}
        </div>
    )
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.token !== null,
    language: state.home.selected_language
});

export default connect(mapStateToProps)(Activities);